import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "../../Assets/Styles/AboutUs/MeetTeam.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper";
import useWindowDimensions from "./windowDiamension";

const teamMembers = [
  {
    image: "assets/images/joson.jpg",
    name: "Jason Hubert",
    post: "CEO/CTO",
  },
  {
    image: "assets/images/bethAdmin.png",
    name: "Beth Tofel",
    post: "President/COO",
  },
  {
    image: "assets/images/customerService.png",
    name: "Marketing Team",
    post: "",
  },
  {
    image: "assets/images/sales.png",
    name: "",
    post: "Sales Team",
  },
  {
    image: "assets/images/amanda.png",
    name: "Customer Service",
    post: "",
  },
];
function MeetTeam() {
  const { width } = useWindowDimensions();

  const getSlidesPerView = () => {
    if (width > 1699) return 5;
    if (width > 1350) return 4;
    if (width > 1100) return 3;
    if (width > 650) return 2;
    return 1;
  };

  const getSpaceBetween = () => {
    if (width > 1024) return 30;
    if (width > 768) return 20;
    return 10;
  };

  return (
    <div className="TeamWrapper">
      <h2 className="TeamHeader">Meet Our <span>Team</span></h2>
      <p className="TeamBody">
        We are a team of passionate individuals dedicated to making a difference
      </p>
      <div className="ImgSlideShow main-swiper">
        <Swiper
          slidesPerView={getSlidesPerView()}
          spaceBetween={getSpaceBetween()}
          slidesPerGroup={1}
          loop={true}
          loopFillGroupWithBlank={true}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          modules={[Pagination, Navigation]}
          className="mySwiper"
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 10
            },
            650: {
              slidesPerView: 2,
              spaceBetween: 15
            },
            1100: {
              slidesPerView: 3,
              spaceBetween: 20
            },
            1350: {
              slidesPerView: 4,
              spaceBetween: 25
            },
            1699: {
              slidesPerView: 4,
              spaceBetween: 30
            }
          }}
        >
          {teamMembers?.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="swiper-slide">
                <div className="team-image-container">
                  <img
                    src={item?.image}
                    className="img-fluid img-team-details"
                    alt={item?.name || item?.post}
                    loading="lazy"
                  />
                </div>
                <p className="tame-data-details">{item?.name}</p>
                <p className="tame-data-details">{item?.post}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
export default MeetTeam;
